import React, { PropTypes } from 'react';
import { FontIcon } from 'material-ui';

const AddItemCard = ({ onClick, text, color }) => {
  return (
    <div
      className="add-item-card-flex"
      onClick={onClick}
    >
      <div style={{ border: `1px dashed ${color}`, height: '32px', width: '32px', display: 'inline-block' }} >
        <FontIcon style={{ verticalAlign: 'middle', color, fontSize: '26px', marginTop: '2px', marginLeft: '2px' }} className="tc-icon-add" />
      </div>
      <span style={{ margin: '0px 0px 0px 24px', color, display: 'inline-block', verticalAlign: 'middle' }}>
        {text}
      </span>
    </div>
  );
};

AddItemCard.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  color: PropTypes.string,
};

export default (AddItemCard);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-item-card/AddItemCard.jsx